import script from "./editableCell.vue?vue&type=script&lang=ts&setup=true"
export * from "./editableCell.vue?vue&type=script&lang=ts&setup=true"

import "./editableCell.vue?vue&type=style&index=0&id=7196dd5e&lang=less"

const __exports__ = script;

export default __exports__